import React, { useEffect, useRef } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import FeaturesCards from './FeaturesCards';
import Quotes from './Quotes';
import { useLocation } from "react-router-dom";

function Features() {
  const videoRef = useRef(null);

  const mrnudgesRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const options = {
      root: null,
      rootMargin: '50px',
      threshold: 0.1,
    };

    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!video.src) {
            video.src = video.dataset.src;
          }
          video.play().catch((error) => console.warn('Video play error:', error));
          observer.unobserve(video);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, options);
    observer.observe(video);

    const scrollToAnchor = () => {
      if (location.hash === "#mrnudges") {
          setTimeout(() => {
              const target = document.getElementById("mrnudges");
              if (target) {
                  target.scrollIntoView({ behavior: "smooth", block: "start" });
              }
          }, 300); // Small delay to ensure page content has loaded
      }
    };

    scrollToAnchor();

    return () => {
      observer.disconnect();
    };
  }, [location]);

  return (
    <>
      <section className="theme-light section m-0 p-0" data-theme="light">
        <div className="m-0 p-0 is-flex is-flex-direction-column is-justify-content-start">
          
          {/* Navigation */}
          <div className="columns is-flex is-flex-direction-rows is-justify-content-center">
            <div className="m-0 p-0 column is-11">
              <Navigation />
            </div>
          </div>

          {/* Content */}
          <div className='p-0 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
            <div className="m-0 p-0 content column is-8-fullhd is-8-widescreen is-10-desktop is-10-tablet is-10-mobile">
              <h1 className='pt-4 m-0'>Features</h1>
              <h3 className='pt-2 pb-4 m-0 is-medium'>
                Reminder apps, to-do lists, Post-its, whiteboards—why not use them all and create a full-time job just managing your reminders? Or, you know, use Nudgemail: one email sent at the right time, so you get stuff done (without the app-induced existential crisis).
              </h3>
            </div>
          </div>

          {/* Cards */}
          <div className='p-0 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
            <div className="m-0 p-0 content column is-8-fullhd is-8-widescreen is-10-desktop is-10-tablet is-10-mobile">
              <div className='pt-6 has-text-centered'>
                <h2 className='is-bold p-0 m-0'>What you get with Nudgemail</h2>
                <h3 className='is-normal pt-1 m-0'>(besides a way more organized future-you)</h3>
              </div>
            </div>
          </div>

          <div className="m-0 pt-2 columns is-flex is-justify-content-center">
            <div className="column is-8">
              <div className="card-grid">
                <FeaturesCards />
              </div>
            </div>
          </div>

          {/* What people say */}
          <div className='px-0 pt-6 columns is-flex is-flex-direction-rows is-justify-content-center'>
            <div className="m-0 px-0 pt-6 content column is-8-fullhd is-8-widescreen is-10-desktop is-10-tablet is-10-mobile">
              <h2 className='is-bold m-0'>How customers use Nudgemail...</h2>
              <h3 className='is-normal pt-1 m-0'>It is so simple, you'll find a million uses (but let's start with a few). <a href="/contact" className='textLink'>Let us know</a> your favorite way.</h3>
            </div>
          </div>

          <div className="m-0 pt-1 columns is-flex is-justify-content-center">
            <div className="column is-9">
              <Quotes />
            </div>
          </div>

          {/* Meet Mr. Nudges */}
          <div className='px-0 pt-6 columns is-flex is-flex-direction-rows is-justify-content-center'>
            <div className="pt-6 column is-10-mobile is-10-tablet is-10-desktop is-8-widescreen is-8-fullhd">
              <div className="columns is-variable is-6">
                
                {/* Video Column */}
                <div className="column is-6">
                  <div className="video-container" style={{ aspectRatio: '1/1' }}>
                    <video
                      ref={videoRef}
                      data-src="/videos/Nudgemail-MrNudges.mp4"
                      playsInline
                      muted
                      loop
                      className="has-ratio"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '8px',
                      }}
                    />
                  </div>
                </div>

                {/* Text Column */}
                <div className="column is-6 is-flex is-flex-direction-rows is-justify-content-center is-align-items-center">
                  <div className="content">
                    <h2 className='is-bold m-0'>Meet Mr. Nudges</h2>
                    <h3 className='is-normal pt-1 m-0'>
                      This friendly, cross-eyed dude is our slightly smug, AI-powered backend developer who ensures your Nudges land 
                      <span className='is-italic'> precisely</span> when needed. 
                    </h3>
                    <div className="my-5 is-flex is-flex-direction-row is-flex-wrap-wrap">
                      <a href="/sign-up" className="button">Make Mr. Nudges happy</a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* Footer */}
          <div className='footer m-0 p-0 columns is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
            <div ref={mrnudgesRef} id="mrnudges" className="m-0 p-0 column is-11 is-10-mobile">
              <Footer />
            </div>
          </div>

        </div> 
      </section>
    </>
  );
}

export default Features;
